export default __webpack_public_path__ + "static/media/Trillium-960px-360px.44cdf448.jpg";